import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../../../../services/toast.service';
import { ProducaoParam } from '../../../../../types/ProducaoParam.type';
import { ProducaoParamService } from '../producaoparam.service';

@Component({
  selector: 'app-producaoparamform',
  templateUrl: './producaoparamform.component.html',
  styleUrl: './producaoparamform.component.css'
})
export class ProducaoParamFormComponent implements OnInit {

  producaoParam: ProducaoParam = {} as ProducaoParam;
  emEdicao: boolean = false;

  tiposProcesso = [
    { label: 'L - LPD', value: 'L' },
    { label: 'P - Produtos Acabados', value: 'P' },
    { label: 'C - Cana', value: 'C' },
  ];

  constructor(private producaoParamService: ProducaoParamService, private toastService: ToastService,
              private activatedRoute: ActivatedRoute, private location: Location) {}

  ngOnInit(){
    this.buscaProducaoParam();
  }

  buscaProducaoParam(){
    const empCodemp = this.activatedRoute.snapshot.paramMap.get('empCodemp');
    const varCodigo = this.activatedRoute.snapshot.paramMap.get('varCodigo');
    const sufCodigo = this.activatedRoute.snapshot.paramMap.get('sufCodigo');

    if (empCodemp && varCodigo && sufCodigo) {
      this.emEdicao = true;

      this.producaoParamService.getOne(empCodemp, varCodigo, sufCodigo).subscribe({
        next: (data) => {
          this.producaoParam = data;
        },
        error: (error) => {
          console.error(error);
          this.toastService.erro("Erro", error.error);
        }
      });
    }
  }

  salvar() {
    if (this.emEdicao) {

      this.producaoParamService.put(this.producaoParam).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Parâmetro de produção atualizado com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error);
        },
      });
    } else {

      this.producaoParamService.post(this.producaoParam).subscribe({
        next: (valor) => {
          Object.assign(this.producaoParam, valor);
          this.toastService.sucesso('Sucesso', 'Parâmetro de produção salvo com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error);
        },
      });
    }
  }

  fecharDialog() {
    this.producaoParam = {} as ProducaoParam;
    this.location.back();
  }

  paraData(valor: string | number | null | undefined): Date | null {
    if (valor === null || valor === undefined || valor === '') {
      return null;
    }

    // A API retorna os campos Instant como epoch em segundos (com fração de nanossegundos)
    // em vez de string ISO-8601, então um número aqui precisa ser convertido para milissegundos.
    return typeof valor === 'number' ? new Date(valor * 1000) : new Date(valor);
  }
}
